import { Routes } from '@angular/router';

export const newsLetterRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/news-letter/news-letter.component').then(c => c.NewsLetterComponent),
    data: { pageTitle: 'PAGES.NEWS_LETTER.TITLE', pageType: 'list', isAnonymous: true }
  }
];
